import type { ContractClientDependencies } from './contract-client';
import type { ApiRegistry } from './provider';
import type { MockProviderOptions } from './providers/mock/types';
import { createBackendApiRegistry } from './create-backend-api';

export type RuntimeApiOptions =
  | { readonly mode: 'backend'; readonly backend: ContractClientDependencies }
  | { readonly mode: 'mock'; readonly mock?: MockProviderOptions };

export async function createRuntimeApiRegistry(options: RuntimeApiOptions): Promise<ApiRegistry> {
  if (options.mode === 'backend') return createBackendApiRegistry(options.backend);
  const { createMockProvider } = await import('./providers/mock');
  return createMockProvider(options.mock);
}
